// extracted by mini-css-extract-plugin
export default {"root":"ResetOtp_root__Ykk3+"};